import cn from "classnames";
import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import { DetailedTable } from "../DetailedTable";

import styles from "./IncomeAndExpensesCard.module.scss";

const renderValueByKey = (value: any, key: string) => {
  if (typeof value[key] === "string") {
    return value[key];
  }

  if (typeof value[key] === "object") {
    const { price, pricePerSquareMeter, area } = value[key];

    return (
      <>
        {price ? convertValueToLocale(price, null, "€", null) : ""}
        {pricePerSquareMeter
          ? `(${convertValueToLocale(pricePerSquareMeter, null, "€/m²", null)})`
          : ""}
        {area ? convertValueToLocale(area, null, "m²", null) : ""}
      </>
    );
  }
};

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    default: {
      const rowKey = item?.key;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{
            minWidth,
            maxWidth,
            justifyContent: justifyContent,
            padding: "8px 12px",
          }}
        >
          <Typography
            className={cn(styles.text, {
              [styles.sumText]: rowKey === "monthlySeparator",
            })}
            variant="numbers"
          >
            {renderValueByKey(item, key)}
          </Typography>
        </div>
      );
    }
  }
};

const IncomeAndExpensesCard = ({
  incomeAndExpenses,
  columnsIncomeAndExpenses,
  generalExpenses,
  columnsGeneralExpenses,
}: any) => {
  return (
    <>
      <DetailedTable
        title="Mieteinnahmen und laufende Nebenkosten"
        data={incomeAndExpenses}
        columns={columnsIncomeAndExpenses}
        cellRenderer={(props) => _cellRenderer(props)}
      />
      <DetailedTable
        title={null}
        data={generalExpenses}
        columns={columnsGeneralExpenses}
        cellRenderer={(props) => _cellRenderer(props)}
      />
    </>
  );
};

export default IncomeAndExpensesCard;
